<template>
  <el-row class="full-height" :gutter="10" style="margin: 0px; padding: 10px 4px">
    <el-col class="full-height" :span="8">
      <el-container class="full-height">
        <el-header height="auto" class="no-padding">
          <el-form size="small" label-position="top">
            
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="Nome">
                  <el-input v-model="bairrosPesquisaForm.nome" size="small" @keyup.enter.native="atualizarBairros"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Cidade">
                  <el-input v-model="bairrosPesquisaForm.cidade.nome" size="small" @keyup.enter.native="atualizarBairros"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="UF">
                  <el-select
                    v-model="bairrosPesquisaForm.cidade.estado.id"
                    size="small"
                    clearable
                    @clear="bairrosPesquisaForm.cidade.estado.id = undefined"
                  >
                    <el-option 
                      v-for="item in estados"
                      :key="item.id"
                      :label="item.sigla"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col>
                <el-button @click="limparForm" size="small" type="success">Novo</el-button>
                <el-button @click="atualizarBairros" size="small" type="primary">Pesquisar</el-button>
                <el-button @click="limparFormPesquisa" size="small" type="warning">Limpar</el-button>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col>
                <span style="font-size: 14px; color: #777">{{ labelQuantidadeBairros }}</span>
              </el-col>
            </el-row>

          </el-form>
        </el-header>

        <el-main style="height: 100%; padding: 0px; margin-top: 10px">
          <el-table
            @row-dblclick="handleRecuperarBairro"
            :data="listaBairros"
            empty-text="Nenhum Bairro"
            height="92%"
            size="small"
            highlight-current-row
            stripe
          >
            <el-table-column label="Estado" width="100">
              <template slot-scope="scope">
                {{ scope.row.cidade.estado.nome }}
              </template>
            </el-table-column>
            <el-table-column label="Cidade" width="100">
              <template slot-scope="scope">
                {{ scope.row.cidade.nome }}
              </template>
            </el-table-column>
            <el-table-column label="Nome">
              <template slot-scope="scope">
                {{ scope.row.nome }}
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            layout="prev,pager,next"
            background
            style="margin-top: 10px"
            @current-change="handleCurrentChange"
            :page-size="100"
            :total="quantidadeBairros"
            :current-page.sync="currentPageBairros"
          />
        </el-main>

      </el-container>
    </el-col>

    <el-col :span="16" class="full-height">
      <el-container class="full-height">
        <el-header height="40px" style="padding: 10px 0px">
          <span style="color: #777; font-weight: bold">
            {{ `Bairros - ${bairrosForm.id === 0 ? 'Novo Bairro' : `${bairrosForm.nome}`}` }}
          </span>
        </el-header>

        <el-main class="full-height" style="background: #FFF; padding: 10px 0px 0px 0px">
          <div class="tab-container">
            <el-form
              :model="bairrosForm"
              :rules="validacao"
              ref="form"
              hide-required-asterisk
              :show-message="false"
              size="small">
              <el-row :gutter="12">
                <el-col :span="8">
                  <el-form-item label="Nome" prop="nome">
                    <el-input v-model="bairrosForm.nome"/>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="Cidade" prop="cidade">
                    <el-select
                      v-model="bairrosForm.cidade"
                      :remote-method="filtrarCidadesSelect"
                      :loading="loadingCidades"
                      loading-text="Carregando Cidades"
                      no-data-text="Nenhuma Cidade encontrada"
                      value-key="id"
                      placeholder
                      filterable
                      clearable
                      default-first-option
                      @clear="bairrosForm.cidade = { estado: undefined }"
                      style="width:100%"
                      size="small"
                      reserve-keyword
                      remote
                    >
                      <el-option
                        v-for="item in cidadesDisponiveis"
                        :key="item.id"
                        :label="item.nome"
                        :value="item"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px" v-if="exibirVariacoesNomes">
                <i class="el-icon-document" />
                Variações de nome(p/Importação)
              </div>
              <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px; height: 620px" v-if="exibirVariacoesNomes">
                <el-row :gutter="12">
                  <el-col :span="8">
                    <el-form-item label="Variação">
                      <el-input size="small" v-model="nomeVariacao"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-button @click="adicionarVariacao" size="small" style="width: 200px; margin-top: 5%" type="success">Adicionar</el-button>
                  </el-col>
                </el-row>
                <el-table
                  :data="bairrosForm.variacoesNome"
                  height="90%"
                  style="width: 400px"
                  size="small"
                  highlight-current-row
                  stripe
                >
                  <el-table-column label="Variações">
                    <template slot-scope="scope">
                      {{ scope.row.nome }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form>
          </div>
        </el-main>

        <el-footer height="52px" style="background-color: #D1D1D1; padding: 10px 10px;">
          <el-row style="height: 100%">
            <el-col :span="24" style="height: 100%">
              <el-row type="flex" justify="end" style="padding-top: 0px;">
                <el-button @click="handlerGravarBairro" size="small" type="success">Gravar</el-button>
                <el-button @click="confirmarRemocaoBairro" size="small" type="danger" v-if="exibirBotaoRemover">Remover</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-footer>
      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import { mapState,mapActions } from 'vuex'
import { ESTADOS } from '../../util/constantes'

export default {
  data() {
    return {
      loadingCidades: false,
      nomeVariacao: '',

      currentPageBairros: 1,

      validacao: {
        nome: [{ required: true }],
        cidade: [{ type: "object", required: true,
          fields: {
            estado:{ type: "object", required: true }
          }
        }]
      }
    }
  },

  created() {
    this.atualizarBairros();
  },

  computed:{
    ...mapState('bairrosStore', {
      bairrosForm: (state) => { return state.form },
      bairrosPesquisaForm: (state) => { return state.formPesquisa },
      cidadesDisponiveis: (state) => { return state.cidadesDisponiveis },
      listaBairros: (state) => { return state.bairros },
      quantidadeBairros: (state) => { return state.quantidadeBairros }
    }),

    validarEstado(rule, value, callback) {
      if(this.bairrosForm.cidade.estado) {
        return callback;
      } else {
        return callback(new Error());
      }
    },

    exibirVariacoesNomes() {
      return this.bairrosForm.id !== 0;
    },

    exibirBotaoRemover() {
      return this.bairrosForm.id !== 0;
    },

    estados() {
      return ESTADOS;
    },

    labelQuantidadeBairros() {
      switch (this.quantidadeBairros) {
        case 0:
          return 'Nenhum bairro encontrado';
        case 1:
          return '1 bairro encontrado'
        default:
          return `${this.quantidadeBairros} bairros foram encontrados`
      }
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('bairrosStore', [
      'recuperarCidades',
      'listarBairros',
      'recuperarBairro',
      'limparForm',
      'gravarBairro',
      'removerBairro',
      'limparFormPesquisa',
      'gravarVariacoesNome'
    ]),

    handlerGravarBairro() {
      this.$refs['form'].validate(valid => {
        if(valid) {
          const payload = { ...this.bairrosForm }

          this.showLoading();

          this.gravarBairro(payload)
          .then(() => {
            this.$message.success('Bairro gravado com sucesso.')
            this.listarBairros({});
          })
          .finally(() => {
            this.hideLoading();
          })
        } else {
          this.$message.warning('Insira os campos obrigatórios.')
        }
      })
    },

    confirmarRemocaoBairro() {
      this.$confirm('Deseja realmente remover este bairro?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.handlerRemoverBairro();
      }).catch(() => {})
    },

    handlerRemoverBairro() {
      const payload = { ...this.bairrosForm }

      this.showLoading();

      this.removerBairro(payload)
      .then((resposta) => {
        if(resposta.status === 'FALHA') {
          this.$message.warning(resposta.mensagem)
        } else {
          this.$message.success(resposta.mensagem)
        }
        
        this.listarBairros({});
      })
      .finally(() => {
        this.hideLoading();
      })
    },

    atualizarBairros() {
      const payload = { ...this.bairrosPesquisaForm }
      this.showLoading();
      this.listarBairros(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      })
    },

    handleRecuperarBairro(bairro) {
      const payload = { id: bairro.id }

      this.showLoading();
      this.recuperarBairro(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      })
    },

    adicionarVariacao() {
      const variacao = {
        nome: this.nomeVariacao
      }

      this.bairrosForm.variacoesNome = []
      
      this.bairrosForm.variacoesNome.push(variacao);
      
      this.showLoading();
      this.gravarVariacoesNome(this.bairrosForm)
      .then(() => {
        this.$message.success('Variação gravada com sucesso.')
      })
      .finally(() => {
        this.hideLoading();
      });
    },

    filtrarCidadesSelect(queryString) {
      const payload = { nome: queryString }

      this.loadingCidades = true;
      this.recuperarCidades(payload)
      .then(() => {
        this.loadingCidades = false;
      })
    },

    handleCurrentChange(pag) {
      const payload = { 
        ...this.bairrosPesquisaForm,
        pagina: pag - 1
      }

      this.listarBairros(payload);
    }
  }
}
</script>